import React, { useEffect, useState } from 'react';
import avatar from '../assets/Mawingubluelogo.png';
import { API_URL, secret_key, currentYear } from '../General';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import Langpage from './Langpage';

function Connected() {
  const storedData = localStorage?.getItem('user');
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);

  let logeduserData = null;
  if (storedData) {
    try {
      const bytes = CryptoJS.AES.decrypt(storedData, secret_key);
      logeduserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (error) {
      console.error('❌ Failed to decrypt or parse user data:', error);
    }
  }

  const navigate = useNavigate();
  const { t } = useTranslation();
  const custno = logeduserData?.Customer_no;

  const handleGoBack = () => {
    navigate(-1);
  };

 const getCustomerDetails = async () => {
  try {
    setLoading(true);
    const res = await axios.post(`${API_URL}/get_customer_details`, { custno });
    const ip = res.data?.ip_address;

    const endpoint = ip?.startsWith("10.40")
      ? `${API_URL}/fibreget_connected_devices`
      : `${API_URL}/connected_devices`;

    const res2 = await axios.post(endpoint, { ipaddress: ip, customer_no: custno });

    let allDevices = [];

    if (Array.isArray(res2.data)) {
      // Handle format: ["mac1\nmac2", "mac3\nmac4"]
      allDevices = res2.data
        .flatMap(item => item.split('\n'))
        .map(mac => mac.trim())
        .filter(mac => mac.length > 0)
        .map(mac => ({ mac }));
    } else {
      // Fallback for object-based responses
      const wired = res2.data?.connected_devices || [];
      const wireless = res2.data?.wireless_devices || [];
      allDevices = [...wired, ...wireless];
    }

    // ✅ Remove duplicates based on MAC address
    const uniqueDevicesMap = new Map();
    allDevices.forEach(device => {
      if (device?.mac) {
        uniqueDevicesMap.set(device.mac, device);
      }
    });

    const uniqueDevices = Array.from(uniqueDevicesMap.values());

    setDevices(uniqueDevices);
  } catch (err) {
    console.error('❌ Error fetching devices:', err.message);
    setDevices([]);
  } finally {
    setLoading(false);
  }
};
  useEffect(() => {
    if (custno) {
      getCustomerDetails();
    }
  }, [custno]);

  return (
    <div className="overlap-group1">
      <div className="logoutlang">
        <button onClick={handleGoBack} className="back-button">
          &lt;&lt; {t('back')}
        </button>
        <Langpage />
      </div>

      <img src={avatar} alt="Mawingu Logo" />

      <div className="div23">
        <div className="text1-wrapper">{t('connected_devices')}</div>

        <div className="wraprshead">
          <div className="text1-wrapper-3">{t('mac_address')}</div>
        </div>

        {loading ? (
          <div className="wraprs">
            <div className="list-item">🔄 {t('loading')}...</div>
          </div>
        ) : devices.length > 0 ? (
          devices.map((device, index) => (
            <div className="wraprs" key={index}>
              <div className="list-item">{device.mac}</div>
            </div>
          ))
        ) : (
          <div className="wraprs">
            <div className="list-item">{t('no_connected_devices')}</div>
          </div>
        )}
      </div>

      <div className="copyright">
        {t('copyright')} © {currentYear} - Mawingu
      </div>
    </div>
  );
}

export default Connected;
